import styled from 'styled-components'
import { H1 } from 'syf-component-library/ui/typography'
import query from 'mediaQueries'
import Icon from 'ui/atoms/Icon'
import { StyledProps } from './typing'
import { getContainerCss } from './helpers'

export const Container = styled.div<StyledProps>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 32px 0 16px;
  min-height: 80px;
  ${({ theme, primary }) => getContainerCss({ theme, primary })}
  @media ${query.greaterThanSmall} {
    padding: 0 32px;
  }
`

export const HeaderText = styled(H1)<StyledProps>`
  font-size: 18px;
  color: ${({ secondary, theme }): string => secondary || theme.modal.text};
`

export const ModalClose = styled.button`
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: flex-end;
  padding: 0;
  border: none;
  background: none;
`

export const CloseIcon = styled(Icon)<StyledProps>`
  font-size: 24px;
  cursor: pointer;
  color: ${({ secondary, theme }): string => secondary || theme.modal.text};
`
